import {generateUUID} from '../utils';
import {genDefaultDynamicCss} from './common';

export const components = () => (
  {
    _id: generateUUID(),
    title: '新建视图',
    components: [{
      type: 'frame',
      prop: 'root',
      parent: '',
      children: [],
      dynamicCss: genDefaultDynamicCss(),
      event: {},
      attrs: {
        title: {
          label: '标题',
          type: 'string',
          value: 'root',
        },
      },
      hook: {},
      comps: {
        subject: 'custom-atom-frame',
        configuration: 'custom-atom-frame-config',
      },
    },
    ],
    type: 'webComponents',
    isTemplate: false,
  }
);

export const slot = () => (
  {
    "prop": generateUUID(),
    "type": "slot",
    "comps": {
      "subject": "custom-atom-slot",
      "configuration": "custom-atom-slot-config"
    },
    "attrs": {
      "title": {
        "label": "名称",
        "type": "string",
        "value": "插槽"
      },
      "templateId": {
        "label": "模板ID",
        "type": "string",
        "value": ""
      },
      "domainCode": {
        "label": "领域code",
        "type": "string",
        "value": ""
      },
      "isDesign": {
        "label": "是否设计态",
        "type": "boolean",
        "value": true
      },
      "components": {
        "label": "页面组件",
        "type": "array",
        "value": []
      }
    },
    "dynamicCss": [],
    "event": {},
    "hook": {},
    "parent": "",
    "children": []
  }
)




